import React from "react";
import { CircularProgress, IconButton } from "@material-ui/core";
import { CheckCircle, CloudDownload } from "@material-ui/icons";

const Download = (props) => {
  const { checked, loading, onDownload, loadingComponent, downloadAriaLabel } = props;
  if (checked) {
    return (
      <IconButton>
        <CheckCircle />
      </IconButton>
    );
  }
  if (loading) {
    if (loadingComponent) {
      return loadingComponent;
    }
    return (
      <IconButton>
        <CircularProgress size={24} />
      </IconButton>
    )
  }
  return (
    <IconButton aria-label={downloadAriaLabel} onClick={onDownload}>
      <CloudDownload />
    </IconButton>
  );
};

export default Download;
